import React, { useMemo } from 'react';
import SeoContentPage from './SeoContentPage';
import { buildInternalLinksForContent } from '../../utils/InternalLinkEngine';
import { localizeInternalLinks } from '../../utils/contentPathLabels';
import { faqItemsFromSections } from './FaqStructured';
import { useLocalizedContent } from '../../hooks/useLocalizedContent';
import { useLocale } from '../../contexts/LocaleContext';
import { seoUiDefaults } from '../../utils/seoUiDefaults';

/**
 * Template data-driven pour les pages /articles/{slug}.
 */
export default function ArticlePageTemplate({ content }) {
  const localizedContent = useLocalizedContent(content);
  const { locale } = useLocale();
  const uiDefaults = seoUiDefaults(locale);

  const enriched = useMemo(() => {
    const faq = localizedContent.faq?.length ? localizedContent.faq : faqItemsFromSections(localizedContent.sections);
    const internalLinks = localizeInternalLinks(buildInternalLinksForContent(localizedContent), locale);

    return {
      ...localizedContent,
      faq,
      internalLinks,
      ctaTitle: localizedContent.ctaTitle || uiDefaults.articleCtaTitle,
      ctaText: localizedContent.ctaText || uiDefaults.articleCtaText,
      ctaButton: localizedContent.ctaButton || uiDefaults.ctaButton,
    };
  }, [localizedContent, uiDefaults]);

  return <SeoContentPage content={enriched} />;
}
